export function log(log) {
  console.log(log);
}
